import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const Condition = () => {
  return (
    <SettingsMetaData propertyName={"VehicleCondition"} viewPropertyName={"Vehicle Condition"}/>
  );
};

export default Condition;
